import { asset } from '../assets';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { ProductGallery } from '../components/ProductGallery';
import { NotesField } from '../components/NotesField';
import { CustomSizeField } from '../components/CustomSizeField';
import { QuoteActions } from '../components/QuoteActions';
import { usePageSetup } from '../hooks/usePageSetup';

const title = "Brochures & Catalogs - INGAZ Print";

function Brochures() {
  usePageSetup({ title });

  return (
    <>
      <SiteHeader />
        <main>
          {/* Product Details Section */}
          <section className="product-details-section">
            <div className="product-container">
              {/* Left: Product Image Gallery */}
              <ProductGallery alt="Brochures" images={[asset('assets/brochure_main_hero_1769364501452.png'), asset('assets/brochure_open_pages_1769358320785.png'), asset('assets/brochure_cover_angle_1769358335257.png'), asset('assets/brochure_stack_spine_1769358349933.png')]} />
              <div className="product-info">
                <h1 className="product-title" data-en="Brochures" data-ar="الكتيبات">Brochures</h1>
                <p className="product-description" data-en="Showcase your products and services with high-quality multi-page brochures." data-ar="اعرض منتجاتك وخدماتك بكتيبات متعددة الصفحات عالية الجودة.">Showcase your products and services with
                  high-quality multi-page brochures.</p>
                <div className="key-features">
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/printing.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Binding Options" data-ar="خيارات التجليد">Binding Options</div>
                      <div className="feature-detail" data-en="Stapled, Wire, Perfect" data-ar="تدبيس، سلك، تجليد فاخر">Stapled,
                        Wire, Perfect</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/star.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Customizable" data-ar="قابل للتخصيص">Customizable</div>
                      <div className="feature-detail" data-en="Your images" data-ar="صورك">Your images</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/truck.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Fast Delivery" data-ar="تسليم سريع">Fast Delivery</div>
                      <div className="feature-detail" data-en="Quick turnaround" data-ar="إنجاز سريع">Quick turnaround</div>
                    </div>
                  </div>
                </div>
                <div className="product-benefits">
                  <h3 data-en="Why this product works" data-ar="لماذا يعمل هذا المنتج">Why this product works</h3>
                  <ul className="benefits-list">
                    <li data-en="Comprehensive way to present your information" data-ar="طريقة شاملة لتقديم معلوماتك">
                      Comprehensive way to present your information</li>
                    <li data-en="Various binding options to suit your page count" data-ar="خيارات تجليد متنوعة لتناسب عدد صفحاتك">
                      Various binding options to suit your page count</li>
                    <li data-en="High-quality cover and inner paper options" data-ar="خيارات ورق غلاف وداخلي عالية الجودة">
                      High-quality cover and inner paper options</li>
                    <li data-en="Professional look for corporate and creative uses" data-ar="مظهر احترافي للاستخدامات المؤسسية والإبداعية">
                      Professional look for corporate and creative uses</li>
                  </ul>
                </div>
                {/* Common Use Cases */}
                <div className="use-cases">
                  <h3 data-en="COMMON USE CASES" data-ar="حالات الاستخدام الشائعة">COMMON USE CASES</h3>
                  <div className="use-cases-grid">
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/store.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Product Catalogs" data-ar="كتالوجات المنتجات">Product Catalogs</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/bag.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Company Profiles" data-ar="ملفات الشركة">Company Profiles</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Event Programs" data-ar="برامج الفعاليات">Event Programs</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/location-dark.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Instruction Manuals" data-ar="أدلة التعليمات">Instruction Manuals
                      </div>
                    </div>
                  </div>
                </div>
                <QuoteActions configureOnly productType={title.replace(' - INGAZ Print', '')} />
                <p className="help-text" data-en="Need help? Our design team is ready to assist you." data-ar="تحتاج مساعدة؟ فريق التصميم لدينا جاهز لمساعدتك.">Need help? Our design team is ready to assist you.
                </p>
              </div>
            </div>
          </section>
          {/* Configuration Section */}
          <section className="configuration-section" id="configuration">
            <div className="config-container">
              <div className="config-main">
                <h2 data-en="Configure Your Brochures" data-ar="قم بتكوين الكتيبات الخاصة بك">Configure Your Brochures</h2>
                {/* Quantity */}
                <div className="config-group">
                  <label htmlFor="quantity" data-en="Quantity" data-ar="الكمية">Quantity</label>
                  <input type="number" id="quantity" placeholder="Enter quantity" min={1} defaultValue={100} data-placeholder-en="Enter quantity" data-placeholder-ar="أدخل الكمية" />
                </div>
                {/* Final Size */}
                <div className="config-group">
                  <label data-en="Final Size" data-ar="الحجم النهائي">Final Size</label>
                  <div className="size-grid">
                    <div className="size-option active" data-size="A4" data-dims="210x297">A4<br /><span>210x297</span></div>
                    <div className="size-option" data-size="A5" data-dims="148x210">A5<br /><span>148x210</span></div>
                    <div className="size-option" data-size="230x230" data-dims="230x230">230×230 mm<br /><span>230x230</span></div>
                    <div className="size-option" data-size="Other" data-dims="Custom"><span data-en="Custom" data-ar="مخصص">Custom</span><br /><span data-en="L × W" data-ar="الطول × العرض">L × W</span></div>
                  </div>
                  <CustomSizeField />
                </div>
                {/* Orientation */}
                <div className="config-group">
                  <label data-en="Orientation" data-ar="الاتجاه">Orientation</label>
                  <div className="side-options">
                    <div className="side-option active" data-orientation="portrait" data-en="Portrait" data-ar="عمودي">
                      <span>Portrait</span>
                    </div>
                    <div className="side-option" data-orientation="landscape" data-en="Landscape" data-ar="أفقي">
                      <span>Landscape</span>
                    </div>
                  </div>
                </div>
                {/* Number of Inside Pages */}
                <div className="config-group">
                  <label htmlFor="insidePages" data-en="Number of Inside Pages" data-ar="عدد الصفحات الداخلية">Number of Inside Pages</label>
                  <input type="number" id="insidePages" placeholder="Enter number of pages" min={4} defaultValue={8} data-placeholder-en="Enter number of pages" data-placeholder-ar="أدخل عدد الصفحات" />
                </div>
                {/* Binding Type */}
                <div className="config-group">
                  <label data-en="Binding Type" data-ar="نوع التجليد">Binding Type</label>
                  <div className="lamination-options">
                    <label className="radio-option"><input type="radio" name="binding" defaultValue="stapled" defaultChecked /><span data-en="Stapled" data-ar="مدبس">Stapled</span></label>
                    <label className="radio-option"><input type="radio" name="binding" defaultValue="white-double-wire" /><span data-en="White double wire" data-ar="سلك مزدوج أبيض">White double wire</span></label>
                    <label className="radio-option"><input type="radio" name="binding" defaultValue="black-double-wire" /><span data-en="Black double wire" data-ar="سلك مزدوج أسود">Black double wire</span></label>
                    <label className="radio-option"><input type="radio" name="binding" defaultValue="silver-single-wire" /><span data-en="Silver metal single wire" data-ar="سلك معدني فضي مفرد">Silver metal single wire</span></label>
                    <label className="radio-option"><input type="radio" name="binding" defaultValue="white-single-wire" /><span data-en="White metal single wire" data-ar="سلك معدني أبيض مفرد">White metal single wire</span></label>
                    <label className="radio-option"><input type="radio" name="binding" defaultValue="decorative-screws" /><span data-en="Decorative Screws" data-ar="براغي زخرفية">Decorative Screws</span></label>
                    <label className="radio-option"><input type="radio" name="binding" defaultValue="perfect" /><span data-en="Perfect binding" data-ar="تجليد فاخر">Perfect binding</span></label>
                  </div>
                  <div className="config-note" data-en="Note to show on website:" data-ar="ملاحظة للعرض على الموقع:">
                    <p><em data-en="Stapling: 8 to 64 pages, inside pages of light or average weight" data-ar="التدبيس: 8 إلى 64 صفحة، صفحات داخلية بوزن خفيف أو متوسط">Stapling: 8 to 64 pages, inside pages of light or average weight</em></p>
                    <p><em data-en="Perfect binding: Should be at least 32 pages, inside pages of light or average weight" data-ar="التجليد الفاخر: يجب أن يكون 32 صفحة على الأقل، صفحات داخلية بوزن خفيف أو متوسط">Perfect binding: Should be at least 32 pages, inside pages of light or average weight</em></p>
                    <p><em data-en="Wire binding" data-ar="تجليد سلكي">Wire binding</em></p>
                  </div>
                </div>

                {/* === COVER SECTION === */}
                <h3 className="config-section-title" data-en="Cover" data-ar="الغلاف">Cover</h3>
                {/* Cover Paper */}
                <div className="config-group">
                  <label htmlFor="coverPaper" data-en="Cover Paper" data-ar="ورق الغلاف">Cover Paper</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="coverPaper">
                      <option value="couche-350">Couche 350 gsm</option>
                      <option value="couche-300">Couche 300 gsm</option>
                      <option value="couche-250">Couche 250 gsm</option>
                      <option value="couche-200">Couche 200 gsm</option>
                      <option value="couche-170">Couche 170 gsm</option>
                      <option value="couche-150">Couche 150 gsm</option>
                      <option value="white-120">White Printing Paper 120 gsm</option>
                      <option value="white-100">White Printing Paper 100 gsm</option>
                      <option value="white-80">White Printing Paper 80 gsm</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                {/* Cover Printing */}
                <div className="config-group">
                  <label data-en="Cover Printing" data-ar="طباعة الغلاف">Cover Printing</label>
                  <div className="color-options">
                    <div className="color-option active" data-color="colored"><span data-en="Full Color" data-ar="ألوان كاملة">Full Color</span></div>
                    <div className="color-option" data-color="bw"><span data-en="Black & White" data-ar="أبيض وأسود">Black &amp; White</span></div>
                  </div>
                </div>
                {/* Cover Printing Sides */}
                <div className="config-group">
                  <label data-en="Cover Printing Sides" data-ar="جوانب طباعة الغلاف">Cover Printing Sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="single"><span>One side</span></div>
                    <div className="side-option" data-sides="double"><span>Double sides</span></div>
                  </div>
                </div>
                {/* Cover Lamination */}
                <div className="config-group">
                  <label data-en="Cover Lamination" data-ar="تغليف الغلاف">Cover Lamination</label>
                  <div className="lamination-options">
                    <label className="radio-option"><input type="radio" name="coverLamination" defaultValue="none" defaultChecked /><span>None</span></label>
                    <label className="radio-option"><input type="radio" name="coverLamination" defaultValue="matt-one" /><span>Matt Cellophane [One side]</span></label>
                    <label className="radio-option"><input type="radio" name="coverLamination" defaultValue="matt-both" /><span>Matt Cellophane [Both sides]</span></label>
                    <label className="radio-option"><input type="radio" name="coverLamination" defaultValue="gloss-one" /><span>Gloss Cellophane [One side]</span></label>
                    <label className="radio-option"><input type="radio" name="coverLamination" defaultValue="gloss-both" /><span>Gloss Cellophane [Both sides]</span></label>
                  </div>
                  <p className="config-note"><em>Note: Cellophane should be dimmed in the case of all White Printing Paper</em></p>
                </div>

                {/* === INSIDES SECTION === */}
                <h3 className="config-section-title" data-en="Insides" data-ar="الصفحات الداخلية">Insides</h3>
                {/* Inside Pages Paper */}
                <div className="config-group">
                  <label htmlFor="insidePaper" data-en="Inside Pages Paper" data-ar="ورق الصفحات الداخلية">Inside Pages Paper</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="insidePaper">
                      <option value="couche-350">Couche 350 gsm</option>
                      <option value="couche-300">Couche 300 gsm</option>
                      <option value="couche-250">Couche 250 gsm</option>
                      <option value="couche-200">Couche 200 gsm</option>
                      <option value="couche-170">Couche 170 gsm</option>
                      <option value="couche-150">Couche 150 gsm</option>
                      <option value="couche-135">Couche 135 gsm</option>
                      <option value="couche-115">Couche 115 gsm</option>
                      <option value="white-120">White paper 120 gsm</option>
                      <option value="white-100">White paper 100 gsm</option>
                      <option value="white-80">White paper 80 gsm</option>
                      <option value="white-70">White paper 70 gsm</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
                {/* Inside Pages Printing */}
                <div className="config-group">
                  <label data-en="Inside Pages Printing" data-ar="طباعة الصفحات الداخلية">Inside Pages Printing</label>
                  <div className="color-options">
                    <div className="color-option active" data-color="colored"><span>Full Color</span></div>
                    <div className="color-option" data-color="bw"><span>Black &amp; White</span></div>
                  </div>
                </div>
                {/* Inside Pages Printing Sides */}
                <div className="config-group">
                  <label data-en="Inside Pages Printing Sides" data-ar="جوانب طباعة الصفحات الداخلية">Inside Pages Printing Sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="single"><span>One side</span></div>
                    <div className="side-option" data-sides="double"><span>Double sides</span></div>
                  </div>
                </div>
                {/* Inside Pages Lamination */}
                <div className="config-group">
                  <label data-en="Inside Pages Lamination" data-ar="تغليف الصفحات الداخلية">Inside Pages Lamination</label>
                  <div className="lamination-options">
                    <label className="radio-option"><input type="radio" name="insideLamination" defaultValue="none" defaultChecked /><span>None</span></label>
                    <label className="radio-option"><input type="radio" name="insideLamination" defaultValue="matt-both" /><span>Matt Cellophane [Both sides]</span></label>
                    <label className="radio-option"><input type="radio" name="insideLamination" defaultValue="gloss-both" /><span>Gloss Cellophane [Both sides]</span></label>
                  </div>
                  <p className="config-note"><em>Note: Cellophane should be dimmed in the case of all White Printing Paper</em></p>
                </div>

                {/* Packaging */}
                <div className="config-group">
                  <label htmlFor="packaging" data-en="Packaging" data-ar="التعبئة والتغليف">Packaging</label>
                  <textarea id="packaging" placeholder="Describe your packaging requirements" rows={3} defaultValue={""} />
                </div>
                {/* Upload Artwork */}
                <div className="config-group">
                  <label data-en="Upload Artwork" data-ar="رفع التصميم">Upload Artwork</label>
                  <div className="upload-area" id="uploadArea">
                    <div className="upload-content">
                      <div className="upload-icon"><img src={asset('assets/upload.svg')} alt="" /></div>
                      <p>Drop your files here or browse</p>
                      <p className="upload-hint">Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)</p>
                    </div>
                    <input type="file" id="fileInput" multiple accept=".pdf,.ai,.eps,.png,.jpg,.jpeg,.psd" style={{display: 'none'}} />
                  </div>
                </div>
                <NotesField />
              </div>
              {/* Request Summary Sidebar */}
              <div className="request-summary">
                <h3 data-en="Request Summary" data-ar="ملخص الطلب">Request Summary</h3>
                <div className="summary-details">
                  <div className="summary-item"><span className="summary-label">Size:</span><span className="summary-value" id="summarySize">A4</span></div>
                  <div className="summary-item"><span className="summary-label">Binding:</span><span className="summary-value" id="summaryBinding">Stapled</span></div>
                  <div className="summary-item"><span className="summary-label">Cover Paper:</span><span className="summary-value" id="summaryCoverPaper">Couche 350 gsm</span></div>
                  <div className="summary-item"><span className="summary-label">Inside Paper:</span><span className="summary-value" id="summaryInsidePaper">Couche 170 gsm</span></div>
                  <div className="summary-item"><span className="summary-label">Cover Lamination:</span><span className="summary-value" id="summaryCoverLam">None</span></div>
                </div>
                <div className="delivery-estimate">
                  <strong data-en="Estimated Delivery" data-ar="التسليم المتوقع">Estimated Delivery</strong>
                  <div className="delivery-time">3-5 business days</div>
                </div>
                <QuoteActions productType={title.replace(' - INGAZ Print', '')} />
                <button className="btn3"><img src={asset('assets/phone.svg')} alt="" /> <span data-en="Contact Support" data-ar="اتصل بالدعم">Contact Support</span></button>
                <div className="guarantees">
                  <div className="guarantee-item">✓ Free design review</div>
                  <div className="guarantee-item">✓ Quality guarantee</div>
                  <div className="guarantee-item">✓ Fast turnaround</div>
                </div>
              </div>
            </div>
          </section>
          {/* Why Choose INGAZ Section */}
          <section className="why-choose-section">
            <div className="why-choose-container">
              <h2 data-en="Why Choose INGAZ?" data-ar="لماذا تختار INGAZ؟">Why Choose INGAZ?</h2>
              <p className="why-choose-subtitle" data-en="Your trusted partner for professional printing solutions" data-ar="شريكك الموثوق لحلول الطباعة الاحترافية">Your trusted partner for professional printing solutions</p>
              <div className="why-choose-grid">
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/quality.svg')} alt="" /></div>
                  <h3 data-en="High Quality" data-ar="جودة عالية">High Quality</h3>
                  <p data-en="Premium materials and cutting-edge printing technology" data-ar="مواد عالية الجودة وتقنيات طباعة متطورة">Premium materials and cutting-edge printing technology
                  </p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                  <h3 data-en="Innovative Solutions" data-ar="حلول مبتكرة">Innovative Solutions</h3>
                  <p data-en="Modern printing techniques for exceptional results" data-ar="تقنيات طباعة حديثة لنتائج استثنائية">Modern printing techniques for exceptional results</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/time.svg')} alt="" /></div>
                  <h3 data-en="Fast Turnaround" data-ar="تسليم سريع">Fast Turnaround</h3>
                  <p data-en="Express delivery options available for urgent orders" data-ar="خيارات تسليم سريع متاحة للطلبات العاجلة">Express delivery options available for urgent orders</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/dollar.svg')} alt="" /></div>
                  <h3 data-en="Value for Money" data-ar="قيمة مقابل المال">Value for Money</h3>
                  <p data-en="Competitive pricing without compromising on quality" data-ar="أسعار تنافسية دون المساس بالجودة">
                    Competitive pricing without compromising on quality</p>
                </div>
              </div>
            </div>
          </section>
          {/* Related Products Section */}
          <section className="related-products-section">
            <div className="related-products-container">
              <h2 data-en="Related Products" data-ar="منتجات ذات صلة">Related Products</h2>
              <p className="related-subtitle" data-en="Explore our full range of printing services" data-ar="استكشف مجموعة كاملة من خدمات الطباعة">Explore our full range of printing services</p>
              <div className="related-products-grid">
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image1.webp')} alt="Business Cards" />
                  </div>
                  <h3 data-en="Business Cards" data-ar="بطاقات العمل">Business Cards</h3>
                  <p data-en="Professional business cards" data-ar="بطاقات عمل احترافية">Professional business cards</p>
                  <a href="/business-cards" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image5.webp')} alt="Brochures" />
                  </div>
                  <h3 data-en="Brochures" data-ar="الكتيبات">Brochures</h3>
                  <p data-en="Multi-page marketing material" data-ar="مواد تسويقية متعددة الصفحات">Multi-page marketing
                    material</p>
                  <a href="/brochures" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image3.webp')} alt="Leaflets" />
                  </div>
                  <h3 data-en="Leaflets" data-ar="المنشورات المطوية">Leaflets</h3>
                  <p data-en="Folded marketing materials" data-ar="مواد تسويقية مطوية">Folded marketing materials</p>
                  <a href="/leaflets" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image7.webp')} alt="Catalogs" />
                  </div>
                  <h3 data-en="Catalogs" data-ar="الكتالوجات">Catalogs</h3>
                  <p data-en="Product catalogs & lookbooks" data-ar="كتالوجات المنتجات والكتيبات">Product catalogs &amp; lookbooks
                  </p>
                  <a href="/catalogues" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image8.webp')} alt="Menus" />
                  </div>
                  <h3 data-en="Menus" data-ar="القوائم">Menus</h3>
                  <p data-en="Restaurant quality printing" data-ar="طباعة بجودة المطاعم">Restaurant quality printing</p>
                  <a href="/menus" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
              </div>
            </div>
          </section>
          {/* Footer */}
          <SiteFooter />
        </main>
    </>
  );
}

export default Brochures;
